import { AuthService } from './auth.service';
import { CindiMessage } from './../models/cindi-message.model';
import { Injectable } from '@angular/core';
import axiosClient from './axios-client';
import { AttachedFilesService } from './attached-files.service';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private allMessages: CindiMessage[] = [];

  constructor(
    private authService: AuthService,
    private attachedFilesService: AttachedFilesService
  ) {}

  getAllCindiMessages() {
    return axiosClient.get('api/cindi/messages').then((res: any) => {
      this.allMessages = res.data.data;
    });
  }

  returnCindiMessage(messageReference: number | string) {
    return this.allMessages.filter(
      (message) =>
        message.id === messageReference || message.tagMensagem === messageReference
    )[0];
  }

  getCindiMessage(messageId: number) {
    return axiosClient.get('api/cindi/messages/' + messageId).then((res: any) => {
      const CindiMessage: CindiMessage = res.data.data;
      return CindiMessage;
    });
  }

  addUserMsgToChat(msg: string) {
    let chat = document.getElementById('chat');

    let p = document.createElement('p');
    p.classList.add('user-msg');
    p.textContent = msg;

    chat?.appendChild(p);
    chat!.scrollTop = chat!.scrollHeight;
  }

  async addBotMsgToChat(
    msg: string,
    customDelay: string | number
  ) {
    let chat = document.getElementById('chat');

    let div = document.createElement('div');
    let p = document.createElement('p');

    div.classList.add('box-bot-msg-img');
    p.classList.add('bot-msg');

    div?.appendChild(p);
    chat?.appendChild(div);

    chat!.scrollTop = chat!.scrollHeight + 500;

    let botDelay: number = 0;
    if (customDelay == 'auto' && msg.length < 250) botDelay = msg?.length * 15;
    else if (customDelay == 'auto' && msg.length >= 250)
      botDelay = msg?.length * 5;
    else botDelay = Number(customDelay);
    if (botDelay < 1000) botDelay = 1000;
    p.classList.add('loading');
    await this.timeout(botDelay);

    document.querySelectorAll('.user-msg').forEach((p) => {
      p.classList.add('option-selected-disabled');
    });

    p.classList.remove('loading');

    p.innerHTML = msg;
    chat!.scrollTop = chat!.scrollHeight + 500;

    new Promise((resolve) => resolve);
  }

  async addStringBotMsgToChat(msg: string, msgDelay: string | number) {
    if (msg.includes('nomePessoa')) {
      const userName = this.authService.getUserName();
      if (userName !== '') {
        msg = msg.replace(
          '{{nomePessoa}}',
          ' <strong>' + userName + '</strong>'
        );
      } else {
        msg = msg.replace(
          '<strong>{{nomePessoa}}</strong>',
          '!'
        );
      }
    }

    if (msg.includes('nomeEmpresa')) {
      const userId = this.authService.getUserId();
      if (userId !== 0) {
        const pessoaDetalhes = await axiosClient.get('api/pessoa/' + userId)
        const nomeEmpresa = pessoaDetalhes.data.empresaNomeFantasia
        msg = msg.replace(
          '{{nomeEmpresa}}',
          ' <strong>' + nomeEmpresa + '</strong>'
        );
      } else {
        msg = msg.replace(
          '<strong>{{nomeEmpresa}}</strong>',
          '!'
        );
      }
    }
    await this.timeout(500);
    await this.addBotMsgToChat(msg, msgDelay);
  }

  async addLocalBotMsgToChat(...params: any[]) {
    let messageReference: number | string = params[0];
    let messageDelay: string | number = params[1];

    if (params[1] == undefined) messageDelay = 'auto';
    const messageObject = this.allMessages.filter(
      (message) =>
        message.id === messageReference || message.tagMensagem === messageReference
    )[0];

    if (messageObject.texto.includes('nomePessoa')) {
      const userName = this.authService.getUserName();
      if (userName !== '') {
        messageObject.texto = messageObject.texto.replace(
          '{{nomePessoa}}',
          ' <strong>' + userName + '</strong>'
        );
      } else {
        messageObject.texto = messageObject.texto.replace(
          '<strong>{{nomePessoa}}</strong>',
          '!'
        );
      }
    }

    if (messageObject.texto.includes('nomeEmpresa')) {
      const userId = this.authService.getUserId();
      if (userId !== 0) {
        const pessoaDetalhes = await axiosClient.get('api/pessoa/' + userId)
        const nomeEmpresa = pessoaDetalhes.data.empresaNomeFantasia
        messageObject.texto = messageObject.texto.replace(
          '{{nomeEmpresa}}',
          ' <strong>' + nomeEmpresa + '</strong>'
        );
      } else {
        messageObject.texto = messageObject.texto.replace(
          '<strong>{{nomeEmpresa}}</strong>',
          '!'
        );
      }
    }

    if (messageObject.texto.includes('*')) {
      messageObject.texto = messageObject.texto.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
    }

    const message: string = messageObject.texto;

    await this.addBotMsgToChat(message, messageDelay);
    new Promise((resolve) => resolve);

    switch (messageObject.id) {
      case 36:
        this.attachedFilesService.downloadPDF();
        break;
      case 51:
        this.attachedFilesService.downloadPDF();
        break;
      case 37:
        this.attachedFilesService.sendImageToChat('qr_code.png');
        break;
      case 52:
        this.attachedFilesService.sendImageToChat('qr_code.png');
        break;
    }
  }

  timeout(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
